export const PASSWORD_MIN_LENGTH = 8;
const PASSWORD_BETTER_LENGTH = 10;

/*
 * Returns an object based on password strength:
 * {
 *    scaledScore: Integer 0, 1, 2, 3, 4
 *    hasMinLength: boolean
 *    hasMixedCase: boolean
 *    hasNonAlphas: boolean
 * }
 */
export const getPasswordStrength = (
  password: string = ''
): {
  scaledScore: number;
  hasMinLength: boolean;
  hasMixedCase: boolean;
  hasNonAlphas: boolean;
} => {
  const hasMinLength = password.length >= PASSWORD_MIN_LENGTH;
  const hasBetterLength = password.length >= PASSWORD_BETTER_LENGTH;
  const minLengthScore = hasMinLength ? 1 : 0;
  const betterLengthScore = hasBetterLength ? 1 : 0;
  const hasNonAlphas = Boolean(password.match(/[^a-zA-Z]/));
  const hasMixedCase = Boolean(password.match(/[a-z]/)) && Boolean(password.match(/[A-Z]/));
  const nonAlphaScore = hasNonAlphas ? 1 : 0;
  const mixedCaseScore = hasMixedCase ? 1 : 0;
  const intermediateScore =
    8 * minLengthScore + 4 * nonAlphaScore + 2 * mixedCaseScore + betterLengthScore;
  let scaledScore = 0;
  if (intermediateScore >= 15) {
    // Meets all rules. (Max score is 15)
    scaledScore = 4;
  } else if (intermediateScore >= 14) {
    // Has minimum length and non alphas and mixed case
    scaledScore = 3;
  } else if (intermediateScore >= 12) {
    // Has minimum or better length and non alphas.
    scaledScore = 2;
  } else if (intermediateScore >= 8) {
    // Has minimum length only.
    scaledScore = 1;
  }
  return {
    hasMinLength,
    hasMixedCase,
    hasNonAlphas,
    scaledScore,
  };
};
